// Copyright 2005-2011 David Caldwell <david@greenfelt.net>

var ajax = require('./ajax'), loadJSON=ajax.loadJSON, makeurl=ajax.makeurl;
var Login = require('./login');
var prnt = require('./print'), sprintf=prnt.sprintf, print=prnt.print;
var dom = require('./dom'), doc=dom.doc;
var lib = require('./lib'), map=lib.map;

function elapsed(seconds) {
    var s=[];
                 s.unshift(Math.floor(seconds % 60) + "s"); seconds = Math.floor(seconds / 60);
    if (seconds) s.unshift(Math.floor(seconds % 60) + "m"); seconds = Math.floor(seconds / 60);
    if (seconds) s.unshift(Math.floor(seconds % 24) + "h"); seconds = Math.floor(seconds / 24);
    if (seconds) s.unshift(Math.floor(seconds %  7) + "d"); seconds = Math.floor(seconds /  7);
    if (seconds) s.unshift(Math.floor(seconds)      + "w");

    return s.slice(0,2).join('');
}

function elapsed_digital(seconds) {
    let m = sprintf("%02d:%02d", seconds / 60, seconds %60).match(/^(0*)(.*)/);
    return ['span', ['span', { className: 'zeros' }, m[1] ], m[2]];
}

function highscore_query(url, completion) {
    loadJSON(url,
             function(scores, error, status) {
                 completion(scores && scores.high_score_table, error, status);
             });
}

function highscore_leaders(seed, options, completion) {
    highscore_query(makeurl('query','leaders',seed.join(","), options), completion);
}

function highscore_seed(title, seed, options, completion) {
    highscore_query(makeurl('query','leaders',seed,title, options), function (scores, error, status) {
            if (scores) scores = scores[seed];
            if (scores) scores = scores[title];
            return completion(scores,error,status);
        });
}

function highscore_day(title, days, options, completion) {
    highscore_query(makeurl('query', 'high', 'days', days, title, options), completion);
}

function highscore_wins(title, days, options, completion) {
    highscore_query(makeurl('query', 'wins', days, title, options), completion);
}

const formatter = new Intl.DateTimeFormat(navigator.languages, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
});

function short_date(date) {
    var d = new Date();
    d.setTime(date * 1000);
    return formatter
        .format(d)
        .replace(", "," ")
        .replace(/\s+(AM|PM)$/,  (_, p) => p.toLowerCase());
}

function censor(name) {
    name = "".normalize ? name.normalize("NFD") : name;
    return name.match(/[aeiouy]/i) ? name.replace(/[aeiouy]/gi,"♥") : name[0]+"♥".repeat(name.length-1)
}

function render_highscores(div, scores, play_id, append, rerender, order) {
    var show_name=false, show_seed=false, show_moves=false;
    if (!scores) { print("unable to load high scores\n"); return; } // this should be rendered in the highscore box!
    for (var i=0; i<scores.length; i++) {
        if (i && scores[i].seed != scores[i-1].seed)
            show_seed = true;
        if (i && scores[i].name != scores[i-1].name)
            show_name = true;
        if (scores[i].moves != null)
            show_moves = true;
    }
    let start = 0;
    var table = doc(
      ["div", {className: "highscore", style: {border: "none"}},
       ["table",
        ["tbody",
         ["tr", {className:"hiscore sort-"+order},
          !scores[0] || !scores[0].place ? {} : ["th", {className:"place"}, "#"],
                                                ["th", {className:"name"},  "Name"],
                                                ["th", {className:"date"},  "Date"],
          !show_name || !scores[0].name ? {} :  ["th", {className:"title"}, "Game"],
          !show_seed ? {} :                     ["th", {className:"seed"},  "Game #"],
                                                ["th", {className:"score"}, "Score"],
          !show_moves ? {} :                    ["th", {className:"moves"}, rerender && order != "moves"   ? ["a",{href:'#',onclick:function() { rerender("moves");   return false; }},"Moves"] : "Moves"],
                                                ["th", {className:"time"},  rerender && order != "elapsed" ? ["a",{href:'#',onclick:function() { rerender("elapsed"); return false; }},"Time" ] : "Time" ]],
         map(function (score,i) {
             let discontinuous = i>0 && scores[i-1].place != score.place && score.place-1 != start+i;
             if (discontinuous)
                 start = score.place-1-i;
             var user_link = function(name) { return !Login.is_admin ? name : ["a", { href: makeurl("@" + score.user) }, name ] };
                 return (
                 ["tr", {className : (play_id && score.play_id == play_id ? " lastscore" : "")
                                   + (Login.is_logged_in() && score.user == Login.user ? " myscore"   : score.banned ? " banned" : "")
                                   + (discontinuous ? " discontinuous" : "") },
                  !score.place ? {} :              ["td", {className:"place"}, i>0 && scores[i-1].place == score.place ? '' : score.place],
                  !score.banned || Login.is_logged_in() && score.user == Login.user
                                                 ? ["td", {className:"name"}, user_link(score.user)]
                                                 : ["td", {className:"name",title:score.user}, user_link(censor(score.user))],
                                                   ["td", {className:"date"}, short_date(score.date)],
                  !show_name || !score.name ? {} : ["td", {className:"title"}, score.name],
                  !show_seed ? {} :                ["td", {className:"seed"}, ["a", { href: (score.name ? score.name :
                                                          document.URL.split('?')[0]) + "?game=" + score.seed }, score.seed]],
                                                   ["td", {className:"score"},
                                                          !Login.is_admin ? score.score : ["a", { href: "/play/id/"+score.play_id }, score.score]],
                  !show_moves ? {} :               ["td", {className:"moves"},
                                                          !Login.is_admin ? score.moves || '' : ["a", { href: "/play/replay/"+score.play_id }, score.moves || ""]],
                                                   ["td", {className:"time"}, elapsed(score.elapsed)]]
             )}, scores)]]]);
    var parent = div.parentNode;
    if (append)
        div.appendChild(table);
    else if (parent)
        parent.replaceChild(table, div);
    return table;
}

function append_highscores(div, scores, play_id) {
    return render_highscores(div, scores, play_id, true);
}

function render_wins(wins) {
    return doc(
        ["div", {className: "highscore", style: { border: "none" }},
         ["table",
          ["tbody",
           ["tr", {className: "hiscore"},
            ["th", {className: "place"}, "#" ],
            ["th", {className: "name"},  "Name" ],
            ["th", {className: "wins"},  "Wins" ]],
           map(function (win, i) {
               return ["tr", {className: (Login.is_logged_in() && win.user == Login.user ? "myscore" : "") },
                       ["td", {className: "place" }, i>0 && wins[i-1].place == win.place ? '' : win.place],
                       ["td", {className: "name"  }, win.user],
                       ["td", {className: "wins"  }, win.wins]];
           }, wins)]]]);
}

function SetTextContents(div, text) {
    doc.clear(div).appendChild(document.createTextNode(text));
}

class IntervalViewer {
    constructor(title) {
        this.title = title;
        function interval(days) { return {days:days} };
        this.timeframe = {/*"This Game": { sql:"seed=?" }, */"Today": interval(1), "This Week": interval(7), "This Month": interval(30), "All Time": interval("all")};
    }
    init() {
        this.switch_timeframe("This Week");
    }
    switch_timeframe(new_t) {
        this.update_timeframe_tabs(new_t);
        this.days = this.timeframe[new_t].days;
        this.current_timeframe = new_t;
        this.refresh();
    }
    refresh(play_id) {
        if (play_id != undefined) this.play_id = play_id;
        this.loading();
        this.query((results, error, status) => {
            if (error) this.error(error);
            else       this.render(results);
        });
    }
    query() {}
    render(results) {}
    error(error) {}
}

class HighScoreIntervalViewer extends IntervalViewer {
    constructor(title) {
        super(title);
    }

    query(complete) {
        highscore_day(this.title, this.days,
                      this.play_id == undefined ? { } : { include: this.play_id },
                      complete);
    }
}

class HighScoreIntervalViewerBrowser extends HighScoreIntervalViewer {
    constructor(div, tabs_div, title) {
        super(title);
        this.el = { highscore: div,
                    tabs: tabs_div };
        for (var t in this.timeframe) {
            this.el.tabs.appendChild(this.timeframe[t].td = doc(["td", ["a", { href:"#",
                                                                           onclick:function(t) {
                                                                               return function() {
                                                                                   this.switch_timeframe(t);
                                                                                   return false;
                                                                               }.bind(this)
                                                                           }.bind(this)(t)
                                                                         }, t]]));
        }
        this.init();
    }

    update_timeframe_tabs(new_t) {
        for (var t in this.timeframe)
            this.timeframe[t].td.className = t == new_t ? "selected" : undefined;
    }

    loading() {
        SetTextContents(this.el.highscore, "Loading High Scores...");
    }

    render(scores) {
        SetTextContents(this.el.highscore, Login.is_logged_in() ? "" : "   (log in or create a new user at the top of the page to get a high score)");
        append_highscores(this.el.highscore, scores, this.play_id);
    }

    error(error) {
        SetTextContents(this.el.highscore, `Unable to load high scores: ${error}`);
    }
}

class WinsIntervalViewerBrowser extends HighScoreIntervalViewerBrowser {
    constructor(div, title) {
        let tabs_div, high_div;
        div.appendChild(doc(["div", {className:"", id:"highscore"},
                             ["table", {className:"intervaltabs"},
                              ["tbody",
                               tabs_div = doc(["tr", {id:"scoretab"}])]],
                             high_div = doc(["div"])]));
        super(high_div, tabs_div, title);
    }

    query(complete) {
        highscore_wins(this.title, this.days, {}, complete);
    }

    render(wins) {
        SetTextContents(this.el.highscores, Login.is_logged_in() ? "" : "   (log in or create a new user at the top of the page to get a high score)");
        this.el.highscores.appendChild(render_wins(wins[this.title]));
    }
}

module.exports = {
    elapsed:                   elapsed,
    elapsed_digital:           elapsed_digital,
    censor:                    censor,
    highscore_query:           highscore_query,
    highscore_leaders:         highscore_leaders,
    highscore_seed:            highscore_seed,
    short_date:                short_date,
    render_highscores:         render_highscores,
    HighScoreIntervalViewer:   HighScoreIntervalViewer,
    HighScoreIntervalViewerBrowser: HighScoreIntervalViewerBrowser,
};
// Copyright 2005-2011 David Caldwell <david@greenfelt.net>

var ajax = require('./ajax'), loadJSON=ajax.loadJSON, makeurl=ajax.makeurl;
var Login = require('./login');
var prnt = require('./print'), sprintf=prnt.sprintf, print=prnt.print;
var dom = require('./dom'), doc=dom.doc;
var lib = require('./lib'), map=lib.map;

function elapsed(seconds) {
    var s=[];
                 s.unshift(Math.floor(seconds % 60) + "s"); seconds = Math.floor(seconds / 60);
    if (seconds) s.unshift(Math.floor(seconds % 60) + "m"); seconds = Math.floor(seconds / 60);
    if (seconds) s.unshift(Math.floor(seconds % 24) + "h"); seconds = Math.floor(seconds / 24);
    if (seconds) s.unshift(Math.floor(seconds %  7) + "d"); seconds = Math.floor(seconds /  7);
    if (seconds) s.unshift(Math.floor(seconds)      + "w");

    return s.slice(0,2).join('');
}

function elapsed_digital(seconds) {
    let m = sprintf("%02d:%02d", seconds / 60, seconds %60).match(/^(0*)(.*)/);
    return ['span', ['span', { className: 'zeros' }, m[1] ], m[2]];
}

function highscore_query(url, completion) {
    loadJSON(url,
             function(scores, error, status) {
                 completion(scores && scores.high_score_table, error, status);
             });
}

function highscore_leaders(seed, options, completion) {
    highscore_query(makeurl('query','leaders',seed.join(","), options), completion);
}

function highscore_seed(title, seed, options, completion) {
    highscore_query(makeurl('query','leaders',seed,title, options), function (scores, error, status) {
            if (scores) scores = scores[seed];
            if (scores) scores = scores[title];
            return completion(scores,error,status);
        });
}

function highscore_day(title, days, options, completion) {
    highscore_query(makeurl('query', 'high', 'days', days, title, options), completion);
}

function highscore_wins(title, days, options, completion) {
    highscore_query(makeurl('query', 'wins', days, title, options), completion);
}

const formatter = new Intl.DateTimeFormat(navigator.languages, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
});

function short_date(date) {
    var d = new Date();
    d.setTime(date * 1000);
    return formatter
        .format(d)
        .replace(", "," ")
        .replace(/\s+(AM|PM)$/,  (_, p) => p.toLowerCase());
}

function censor(name) {
    name = "".normalize ? name.normalize("NFD") : name;
    return name.match(/[aeiouy]/i) ? name.replace(/[aeiouy]/gi,"♥") : name[0]+"♥".repeat(name.length-1)
}

function render_highscores(div, scores, play_id, append, rerender, order) {
    var show_name=false, show_seed=false, show_moves=false;
    if (!scores) { print("unable to load high scores\n"); return; } // this should be rendered in the highscore box!
    for (var i=0; i<scores.length; i++) {
        if (i && scores[i].seed != scores[i-1].seed)
            show_seed = true;
        if (i && scores[i].name != scores[i-1].name)
            show_name = true;
        if (scores[i].moves != null)
            show_moves = true;
    }
    let start = 0;
    var table = doc(
      ["div", {className: "highscore", style: {border: "none"}},
       ["table",
        ["tbody",
         ["tr", {className:"hiscore sort-"+order},
          !scores[0] || !scores[0].place ? {} : ["th", {className:"place"}, "#"],
                                                ["th", {className:"name"},  "Name"],
                                                ["th", {className:"date"},  "Date"],
          !show_name || !scores[0].name ? {} :  ["th", {className:"title"}, "Game"],
          !show_seed ? {} :                     ["th", {className:"seed"},  "Game #"],
                                                ["th", {className:"score"}, "Score"],
          !show_moves ? {} :                    ["th", {className:"moves"}, rerender && order != "moves"   ? ["a",{href:'#',onclick:function() { rerender("moves");   return false; }},"Moves"] : "Moves"],
                                                ["th", {className:"time"},  rerender && order != "elapsed" ? ["a",{href:'#',onclick:function() { rerender("elapsed"); return false; }},"Time" ] : "Time" ]],
         map(function (score,i) {
             let discontinuous = i>0 && scores[i-1].place != score.place && score.place-1 != start+i;
             if (discontinuous)
                 start = score.place-1-i;
             var user_link = function(name) { return !Login.is_admin ? name : ["a", { href: makeurl("@" + score.user) }, name ] };
                 return (
                 ["tr", {className : (play_id && score.play_id == play_id ? " lastscore" : "")
                                   + (Login.is_logged_in() && score.user == Login.user ? " myscore"   : score.banned ? " banned" : "")
                                   + (discontinuous ? " discontinuous" : "") },
                  !score.place ? {} :              ["td", {className:"place"}, i>0 && scores[i-1].place == score.place ? '' : score.place],
                  !score.banned || Login.is_logged_in() && score.user == Login.user
                                                 ? ["td", {className:"name"}, user_link(score.user)]
                                                 : ["td", {className:"name",title:score.user}, user_link(censor(score.user))],
                                                   ["td", {className:"date"}, short_date(score.date)],
                  !show_name || !score.name ? {} : ["td", {className:"title"}, score.name],
                  !show_seed ? {} :                ["td", {className:"seed"}, ["a", { href: (score.name ? score.name :
                                                          document.URL.split('?')[0]) + "?game=" + score.seed }, score.seed]],
                                                   ["td", {className:"score"},
                                                          !Login.is_admin ? score.score : ["a", { href: "/play/id/"+score.play_id }, score.score]],
                  !show_moves ? {} :               ["td", {className:"moves"},
                                                          !Login.is_admin ? score.moves || '' : ["a", { href: "/play/replay/"+score.play_id }, score.moves || ""]],
                                                   ["td", {className:"time"}, elapsed(score.elapsed)]]
             )}, scores)]]]);
    var parent = div.parentNode;
    if (append)
        div.appendChild(table);
    else if (parent)
        parent.replaceChild(table, div);
    return table;
}

function append_highscores(div, scores, play_id) {
    return render_highscores(div, scores, play_id, true);
}

function render_wins(wins) {
    return doc(
        ["div", {className: "highscore", style: { border: "none" }},
         ["table",
          ["tbody",
           ["tr", {className: "hiscore"},
            ["th", {className: "place"}, "#" ],
            ["th", {className: "name"},  "Name" ],
            ["th", {className: "wins"},  "Wins" ]],
           map(function (win, i) {
               return ["tr", {className: (Login.is_logged_in() && win.user == Login.user ? "myscore" : "") },
                       ["td", {className: "place" }, i>0 && wins[i-1].place == win.place ? '' : win.place],
                       ["td", {className: "name"  }, win.user],
                       ["td", {className: "wins"  }, win.wins]];
           }, wins)]]]);
}

function SetTextContents(div, text) {
    doc.clear(div).appendChild(document.createTextNode(text));
}

class IntervalViewer {
    constructor(title) {
        this.title = title;
        function interval(days) { return {days:days} };
        this.timeframe = {/*"This Game": { sql:"seed=?" }, */"Today": interval(1), "This Week": interval(7), "This Month": interval(30), "All Time": interval("all")};
    }
    init() {
        this.switch_timeframe("This Week");
    }
    switch_timeframe(new_t) {
        this.update_timeframe_tabs(new_t);
        this.days = this.timeframe[new_t].days;
        this.current_timeframe = new_t;
        this.refresh();
    }
    refresh(play_id) {
        if (play_id != undefined) this.play_id = play_id;
        this.loading();
        this.query((results, error, status) => {
            if (error) this.error(error);
            else       this.render(results);
        });
    }
    query() {}
    render(results) {}
    error(error) {}
}

class HighScoreIntervalViewer extends IntervalViewer {
    constructor(title) {
        super(title);
    }

    query(complete) {
        highscore_day(this.title, this.days,
                      this.play_id == undefined ? { } : { include: this.play_id },
                      complete);
    }
}

class HighScoreIntervalViewerBrowser extends HighScoreIntervalViewer {
    constructor(div, tabs_div, title) {
        super(title);
        this.el = { highscore: div,
                    tabs: tabs_div };
        for (var t in this.timeframe) {
            this.el.tabs.appendChild(this.timeframe[t].td = doc(["td", ["a", { href:"#",
                                                                           onclick:function(t) {
                                                                               return function() {
                                                                                   this.switch_timeframe(t);
                                                                                   return false;
                                                                               }.bind(this)
                                                                           }.bind(this)(t)
                                                                         }, t]]));
        }
        this.init();
    }

    update_timeframe_tabs(new_t) {
        for (var t in this.timeframe)
            this.timeframe[t].td.className = t == new_t ? "selected" : undefined;
    }

    loading() {
        SetTextContents(this.el.highscore, "Loading High Scores...");
    }

    render(scores) {
        SetTextContents(this.el.highscore, Login.is_logged_in() ? "" : "   (log in or create a new user at the top of the page to get a high score)");
        append_highscores(this.el.highscore, scores, this.play_id);
    }

    error(error) {
        SetTextContents(this.el.highscore, `Unable to load high scores: ${error}`);
    }
}

class WinsIntervalViewerBrowser extends HighScoreIntervalViewerBrowser {
    constructor(div, title) {
        let tabs_div, high_div;
        div.appendChild(doc(["div", {className:"", id:"highscore"},
                             ["table", {className:"intervaltabs"},
                              ["tbody",
                               tabs_div = doc(["tr", {id:"scoretab"}])]],
                             high_div = doc(["div"])]));
        super(high_div, tabs_div, title);
    }

    query(complete) {
        highscore_wins(this.title, this.days, {}, complete);
    }

    render(wins) {
        SetTextContents(this.el.highscores, Login.is_logged_in() ? "" : "   (log in or create a new user at the top of the page to get a high score)");
        this.el.highscores.appendChild(render_wins(wins[this.title]));
    }
}

module.exports = {
    elapsed:                   elapsed,
    elapsed_digital:           elapsed_digital,
    censor:                    censor,
    highscore_query:           highscore_query,
    highscore_leaders:         highscore_leaders,
    highscore_seed:            highscore_seed,
    short_date:                short_date,
    render_highscores:         render_highscores,
    HighScoreIntervalViewer:   HighScoreIntervalViewer,
    HighScoreIntervalViewerBrowser: HighScoreIntervalViewerBrowser,
};
